import * as types from './mutations-types';

export const mutations = {
  [types.SET_SEARCH](state, value) {
    Object.assign(state.search, value);
  },

  [types.SEARCH_RESULTS_SUCCESS](state, results) {
    state.searchResults = results.hits.hits;
    state.numHits = results.hits.total.value;
    state.numDocs = results.aggregations.num_docs.value;
    state.numProducts = results.aggregations.products_agg.num_products.value;
  },

  [types.TOGGLE_LOADING](state, status) {
    state.searchLoading = status;
  },

  [types.SAVE_SEARCH_SUCCESS](state, search) {
    state.savedSearch.push(search);
  },
  [types.DELETE_SEARCH_SUCCESS](state, deleted_id) {
    state.savedSearch = state.savedSearch.filter((search) => {
      return search.id !== deleted_id;
    });
  },

  [types.SHOW_MODAL_SEARCH](state, data) {
    state.modal.filters = data.filters;
    state.modal.query = data.query;
    state.modal.mode = data.mode;
    state.modal.offset = data.offset;
    state.modal.actionDateStart = data.actionDateStart;
    state.modal.actionDateEnd = data.actionDateEnd;
    state.modal.prevNumPages = data.prevNumPages;
  },
  [types.FETCH_SAVED_SEARCH_SUCCESS](state, data) {
    state.savedSearch = data;
  },
};
